import { Col, Row } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import Victor from "../assets/images/Victor.svg";
import stateWrapper from "../containers/provider";
import NavItem from "./NavItem";

const NavBar = (props) => {
  const handleOnClick = (href) => {
    props?.masterStore?.setSelectedBar(href);
  };
  return (
    <>
      <Row
        style={{
          marginBottom: 26,
          marginTop: 26,
          marginLeft: 20,
          marginRight: 10,
        }}
      >
        <Col span={5}>
          <Link
            to="/home"
            onClick={() => {
              handleOnClick("/home");
            }}
          >
            <img
              src={Victor}
              style={{
                width: 120,
                height: 30,
                fontFamily: "Arial Rounded MT Bold",
              }}
            />
          </Link>
        </Col>
        <Col span={19}>
          <Row>
            <Col span={12} />
            <Col span={12}>
              <Row>
                <Col span={8}>
                  <NavItem href="/home" />
                </Col>
                <Col span={8}>
                  <NavItem href="/about" />
                </Col>
                <Col span={8}>
                  <NavItem href="/contact" />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default stateWrapper(NavBar);
